import { render, staticRenderFns } from "./TravelNoteDetailSlideFixed.vue?vue&type=template&id=0316ea07&scoped=true"
import script from "./TravelNoteDetailSlideFixed.vue?vue&type=script&lang=js"
export * from "./TravelNoteDetailSlideFixed.vue?vue&type=script&lang=js"
import style0 from "./TravelNoteDetailSlideFixed.vue?vue&type=style&index=0&id=0316ea07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316ea07",
  null
  
)

export default component.exports